import React from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, CreditCard, Infinity as InfinityIcon } from 'lucide-react';
import { goToCheckout } from '../utils/checkout';
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-32 px-4 overflow-hidden" data-id="element-55">
      {/* Background Glow */}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-[800px] h-[800px] bg-radial-glow pointer-events-none opacity-60" data-id="element-56" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-57">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} data-id="element-58">
          <span className="inline-block text-brand-orange font-bold tracking-widest text-xs md:text-sm uppercase mb-6 border border-brand-orange/30 bg-brand-orange/10 px-4 py-2 rounded-full" data-id="element-59">
            — El Protocolo de Reprogramación Hormonal diseñado para hombres de
            alto rendimiento 40+ —
          </span>
        </motion.div>

        <motion.h1 className="text-5xl md:text-7xl lg:text-8xl font-bold text-white mb-8 leading-[1.1] uppercase" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} data-id="element-60">
          El Reinicio Biológico: <br data-id="element-61" />
          <span className="text-brand-orange" data-id="element-62">
            Recupera la vitalidad y el empuje
          </span>{' '}
          <br data-id="element-63" />
          de tus 25 años en solo 21 días
        </motion.h1>

        <motion.p className="text-lg md:text-xl text-brand-muted mb-10 max-w-3xl mx-auto leading-relaxed" initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} data-id="element-64">
          No es tu edad. No es "falta de voluntad". Es una neblina neuro-química
          causada por el entorno moderno. Aprende a hackear tus niveles de
          Testosterona y Dopamina con el método de biohacking que no requiere
          fármacos, ni vivir en el gimnasio.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} className="flex flex-col items-center" data-id="element-65">
          <button onClick={goToCheckout} className="bg-brand-orange hover:bg-[#ff7b1a] text-black font-display font-bold text-xl md:text-2xl py-5 px-10 w-full md:w-auto rounded-sm transition-all transform hover:scale-105 shadow-[0_0_20px_rgba(255,107,0,0.4)] uppercase tracking-wide" data-id="element-66">
            Sí, quiero el reset biológico por $6.36
          </button>

          <div className="flex flex-wrap justify-center gap-4 md:gap-8 mt-6 text-sm text-brand-muted font-medium" data-id="element-67">
            <div className="flex items-center gap-1.5" data-id="element-68">
              <CreditCard className="w-4 h-4 text-brand-orange" data-id="element-69" />
              <span data-id="element-70">Pago único</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-71">
              <InfinityIcon className="w-4 h-4 text-brand-orange" data-id="element-72" />
              <span data-id="element-73">Acceso de por vida</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-74">
              <ShieldCheck className="w-4 h-4 text-brand-orange" data-id="element-75" />
              <span data-id="element-76">Garantía de 30 días</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}